import { captureException as newrelicCaptureException } from '@/newrelic'

import type { RouteLocationNormalized } from 'vue-router'

export type ValueOfQuery =
  RouteLocationNormalized['query'][keyof RouteLocationNormalized['query']]
export const getQuery = (query: ValueOfQuery): Maybe<string> =>
  (Array.isArray(query) ? query[0] : query) || undefined

// parse JSONString in query => { [key: string]: string }
export const bindStringDictionary = (
  query: ValueOfQuery
): Maybe<Record<string, string>> => {
  const paramsString = getQuery(query)
  try {
    if (paramsString === undefined) {
      return undefined
    }
    const parsed = JSON.parse(paramsString)
    if (typeof parsed !== 'object' || parsed === null) {
      return undefined
    }
    return Object.keys(parsed).reduce<Record<string, string>>(
      (acc, key) => ({
        ...acc,
        [key]: parsed[key]?.toString() ?? '',
      }),
      {}
    )
  } catch (error) {
    newrelicCaptureException(error)
    return undefined
  }
}
